import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'oph-icon',
  templateUrl: './oph-icon.component.html',
  styleUrls: ['./oph-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphIconComponent {
  @Input()
  public name: string;

  @Input()
  public imageErrorName: string = '';

  @HostBinding('style.height.px')
  @HostBinding('style.width.px')
  @Input()
  public size = 24;

  @HostBinding('class.oph-icon')
  public rootClass = true;

  public onImageError(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    if (this.imageErrorName) {
      imgElement.src = `/assets/img/icons/${this.imageErrorName}.svg`;
    }
  }
}
